<template>
  <process-item-tmp
    :show-type="showType">
    <base-info id="budget" @click="showDetail= !showDetail" :data="showData" :config="config"></base-info>
    <budget-detail-info :show-type="showType" v-if="showDetail && showData && showData.id" :budget-detail-id="showData.id"></budget-detail-info>
  </process-item-tmp>
</template>

<script>
import processItemTmp from './processItemTmp'
import budgetDetailInfo from './budgetDetailInfo'
import baseInfo from './baseInfo'

export default {
  components: {
    processItemTmp,
    budgetDetailInfo,
    baseInfo
  },
  props: {
    showType: {
      type: String,
      default: 'row'
    },
    allShowDetail: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: function () {return null}
    }
  },
  watch: {
    allShowDetail: {
      deep: true,
      handler () {
        this.showDetail = this.allShowDetail
      },
      immediate: true
    }
  },
  computed: {
    showData () {
      let data = Object.assign({}, this.data)
      data.passTime = (data.statusActionRecord.find(v => v.newStatusKey === 'final_pass' && !v.isBack) || {createTime: ''}).createTime
      return data
    }
  },
  data () {
    return {
      showDetail: false,
      config: [{
        key: 'code',
        label: '预算编号'
      },
      {
        key: 'goodsName',
        label: '物品名称'
      },
      {
        key: 'budgetApplyOrgName',
        label: '申报科室'
      },
      {
        key: 'goodsAssetsTypeCode',
        label: '国资分类'
      },
      {
        key: 'passTime',
        label: '通过日期',
        format: (data) => {
          return data.passTime ? data.passTime.slice(0, 10) : ''
        }
      },
      {
        key: 'total',
        label: '总价'
      },
      {
        key: 'num',
        label: '数量'
      }]
    }
  }
}
</script>
